module.exports = __webpack_public_path__ + "static/1escaperoom-b56991ce6f4668da73ad2cc7773dd127.png";